export function WhyUs() {
  return `
    <section class="section bg-dark">
      <div class="container text-center">

        <h2 class="mb-3">Kenapa Pilih Kami?</h2>
        <p class="text-secondary mb-5">
          Kami memberikan solusi terbaik untuk kebutuhan digital Anda
        </p>

        <div class="row g-4">

          ${WhyItem("bi-lightning-charge", "Proses Cepat", "Pengerjaan cepat tanpa mengurangi kualitas", 0)}
          ${WhyItem("bi-cash-coin", "Harga Terjangkau", "Biaya ramah untuk UMKM dan personal", 100)}
          ${WhyItem("bi-gear", "Bisa Custom", "Layanan fleksibel sesuai kebutuhan Anda", 200)}
          ${WhyItem("bi-headset", "Support Konsultasi", "Siap membantu dari awal sampai selesai", 300)}

        </div>

      </div>
    </section>
  `;
}

function WhyItem(icon, title, desc) {
  return `
    <div class="col-md-3" data-aos="zoom-in">
      <div class="why-card p-4 text-center h-100">

        <div class="why-icon mb-3">
          <i class="bi ${icon}"></i>
        </div>

        <h6 class="mb-2">${title}</h6>
        <p class="text-secondary small">${desc}</p>

      </div>
    </div>
  `;
}
